import { AxiosResponse } from 'axios'
import AxiosClient from '@services/api/base'
import { CourseProgress } from '@type/course'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Course progress
 * @param courseId
 */
const getCourseProgress = (
  courseId: string | string[]
): Promise<CourseProgress> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + courseId + '/progress'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.get(URL, config)
      .then((res: AxiosResponse<CourseProgress>) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getCourseProgress
